import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule }
	from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { FocusMeDirective } from '../../../shared/directives/focus-me.directive';

@Component({
	selector: 'copo-dialog-batch-not-invoiced',
	templateUrl: './dialog-batch-not-invoiced.component.html',
	styleUrl: './dialog-batch-not-invoiced.component.css',
	encapsulation: ViewEncapsulation.Emulated,

	imports: [TranslateModule, NgIf, MatButtonModule, FocusMeDirective, MatDialogModule]
})
export class DialogBatchNotInvoicedComponent {
	claimedBatch: string | undefined;

	constructor(

		@Inject(MAT_DIALOG_DATA) public data: string[]
	) {
		this.claimedBatch = data.join(', ');
	}
}
